import assetPath from '/app/packages/lebenslauf/constants/src/assets/template-2-preview.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')